import { Outlet } from 'react-router-dom'
import { MenuPreviewToolbar } from '@/components/printMenu/MenuPreviewToolbar'
import '@/styles/print-menu.css'

export function MenuPreviewLayout() {
  return (
    <div className="print-menu-root">
      <MenuPreviewToolbar />
      <Outlet />
    </div>
  )
}
